import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Config } from '../../../config'
import { useScrollTo } from '@sentecacommerce-theme/lib'

import { UpArrow } from '../Icons/UpArrow'

export const ScrollToTopOfPageComponent = () => {
  const [showScroll, setShowScroll] = useState(false)

  const { scrollTo } = useScrollTo(0, 0.1, 'easeInOutSine')

  const checkScrollTop = (pageYOffset: number) => {
    if (!showScroll && window?.pageYOffset > pageYOffset) {
      setShowScroll(true)
    } else if (showScroll && window?.pageYOffset <= pageYOffset) {
      setShowScroll(false)
    }
  }

  useEffect(() => {
    const cb = () => checkScrollTop(400)

    window.addEventListener('scroll', cb)

    return () => window.removeEventListener('scroll', cb)
  }, [])

  return (
    <IconContainer onClick={() => scrollTo(0)} showScroll={showScroll}>
      <StyledArrow />
    </IconContainer>
  )
}

const IconContainer = styled.span.attrs({
  className: 'flex-column align-items-center justify-content-center m-5 p-2',
})<{ showScroll?: boolean }>`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    display: ${({ showScroll }) =>
      showScroll ? 'flex !important' : 'none !important'};

    width: 4rem;
    height: 4rem;

    position: fixed;
    bottom: 0;
    right: 0;

    cursor: pointer;

    background-color: rgba(102, 102, 102, 0.5);
    color: ${({ theme }) => theme.palette.white};
    box-shadow: 0 0 0.4rem rgb(0 0 0 / 56%);

    border-radius: 0.2rem;

    text-transform: uppercase;
    z-index: 99999;

    font-size: 1rem;

    &:hover {
      background-color: rgba(102, 102, 102, 0.7);
    }
  }
`

const StyledArrow = styled(UpArrow)`
  fill: ${({ theme }) => theme.palette.white};
  width: 70%;
`
